<template>
<div style="text-align: center;display: block">
  <div style="text-align: center;font-size: 24px;font-weight: bolder;margin-top: 30px;"> 登录系统</div>
  <div style="display: inline-block">
<el-descriptions
  style="margin-top: 20px;max-width: 640px;text-align: center"
  :column="1"
  size="large"
  border
>
  <el-descriptions-item :min-width="50">
    <template #label>
      <div class="cell-item">
        <el-icon style="width: 24px;">
          <User />
        </el-icon>
        账号
      </div>
    </template>
    <el-input v-model="formRef.account" placeholder="请输入账号"></el-input>
  </el-descriptions-item>
  <el-descriptions-item :min-width="100">
    <template #label>
      <div class="cell-item">
        <el-icon style="width: 24px;">
          <Lock />
        </el-icon>
        密码
      </div>
    </template>
    <el-input v-model="formRef.password" type="password" placeholder="请输入密码"></el-input>
  </el-descriptions-item>
  <el-descriptions-item label=" " :min-width="100">
    <el-button type="primary" @click="onLoginClick">登录</el-button>
  </el-descriptions-item>
</el-descriptions>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import {
  Lock,
  User
} from "@element-plus/icons-vue";
import rest from "@/rest";
import { ElMessage } from "element-plus";
import { setLocalStorage } from "@/utils/localStorage";
export default defineComponent({
  components: { User, Lock },
  emits: ["login-success"],
  expose: [],
  setup (props, { emit }) {
    const formRef = ref<Record<string, any>>({});
    const onLoginClick = () => {
      console.log(formRef.value);
      if (!formRef.value.account || !formRef.value.password) {
        ElMessage.error("请输入账号和密码");
        return;
      }
      rest.baFutureData({ action: "LOGIN", data: formRef.value }, (res:any) => {
        console.log(res);
        setLocalStorage("token", res.token, 7200);
        ElMessage.success("登录成功");
        emit("login-success");
      }, (error:any) => {
        ElMessage.error(error.message);
      }
      );
    };
    return { formRef, onLoginClick };
  }
});

</script>

<style scoped></style>
